import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environment.ts/environment';

export interface ConversionData {
  filename: string;
  size?: number;
  originalFormat?: string;
  targetFormat?: string;
  file?: File; // Ajouter le fichier uploadé
}

export interface UploadResponse {
  success: boolean;
  message: string;
  data: any;
  timestamp?: string;
}

export interface SendEmailRequest {
  to: string;
  name: string;
  filePath: string;
  siteUrl: string;
  siteName: string;
}

export interface SendEmailResponse {
  success: boolean;
  message: string;
  data: {
    recipient: string;
    filePath: string;
    timestamp: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class FileConversionService {
  private conversionDataSubject = new BehaviorSubject<ConversionData | null>(null);
  public conversionData$ = this.conversionDataSubject.asObservable();

  constructor(private http: HttpClient) {}

  setConversionData(data: ConversionData) {
    this.conversionDataSubject.next(data);
  }

  getConversionData(): ConversionData | null {
    return this.conversionDataSubject.value;
  }

  clearConversionData() {
    this.conversionDataSubject.next(null);
  }

  convertFile(filename: string): Observable<UploadResponse> {
    const formData = new FormData();

    return this.http.post<UploadResponse>(
      `${environment.fileConverterBaseUrl}/api/files/pdf/convert/${filename}`,
      formData
    );
  }

  /**
   * Upload un fichier PDF vers le serveur
   * @param file - Le fichier PDF à uploader
   * @returns Observable<UploadResponse> - La réponse du serveur
   */
  uploadFile(file: File): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<UploadResponse>(
      `${environment.fileConverterBaseUrl}/api/files/pdf/upload`,
      formData
    );
  }

  /**
   * Upload le fichier stocké dans conversionDataSubject
   * @returns Observable<UploadResponse> - La réponse du serveur
   */
  uploadCurrentFile(): Observable<UploadResponse> {
    const conversionData = this.getConversionData();
    if (!conversionData || !conversionData.file) {
      throw new Error('Aucun fichier disponible pour l\'upload');
    }
    
    return this.uploadFile(conversionData.file);
  }

  /**
   * Envoie un email avec le fichier converti
   * @param emailData - Les données pour l'envoi d'email
   * @returns Observable<SendEmailResponse> - La réponse du serveur
   */
  sendConvertedEmail(emailData: SendEmailRequest): Observable<SendEmailResponse> {
    console.log('Envoie email avec les données:', emailData);
    return this.http.post<SendEmailResponse>(
      `${environment.apiBaseUrl}/files/send-converted-email`,
      emailData
    );
  }
} 